import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68628891"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fancyline" }, null, -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fancyline" }, null, -1))
const _hoisted_6 = { key: 1 }

import { translate } from '@/util/intl';
import PasswordLogin from "./PasswordLogin.vue";
import PasswordRegister from "./PasswordRegister.vue";
import {index} from "@/store";
import {AppState} from "@/store/app-state";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationAndLogin',
  setup(__props) {

function switchToLogin(): void {
  index.commit("SET_APP_STATE", AppState.PwdLogin);
}

function switchToRegister(): void {
  index.commit("SET_APP_STATE", AppState.PwdRegister);
}


return (_ctx: any,_cache: any) => {
  return (_unref(index).getters.getAppState === _unref(AppState).PwdLogin)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(PasswordLogin),
        _hoisted_2,
        _createElementVNode("p", null, _toDisplayString(_unref(translate)("not-yet-registered-q")) + "?", 1),
        _createElementVNode("button", {
          class: "buttonContinue",
          onClick: switchToRegister
        }, _toDisplayString(_unref(translate)("begin-registering")), 1)
      ]))
    : (_unref(index).getters.getAppState === _unref(AppState).PwdRegister)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_unref(index).getters.hasAttemptedPassportId)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_unref(translate)("finish-id-verification")), 1))
            : _createCommentVNode("", true),
          _createVNode(PasswordRegister),
          _hoisted_5,
          (!_unref(index).getters.hasAttemptedPassportId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("p", null, _toDisplayString(_unref(translate)("login-q")) + "?", 1),
                _createElementVNode("button", {
                  class: "buttonContinue",
                  onClick: switchToLogin
                }, _toDisplayString(_unref(translate)("generic-sign-in")), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
}
}

})